import isArray from 'lodash/isArray';
import isObject from 'lodash/isObject';
import includes from 'lodash/includes';
import isEqualWith from 'lodash/isEqualWith';
import pickBy from 'lodash/pickBy';
import isEmpty from 'lodash/isEmpty';
import xor from 'lodash/xor';

const comparisonFunc = (a, b) => {
    if (isArray(a) || isArray(b)) return;
    if (!isObject(a) || !isObject(b)) return;

    if (!includes(a, undefined) && !includes(b, undefined)) return;

    // Call recursively, after filtering all undefined properties
    return isEqualWith(
        pickBy(a, (value) => value !== undefined),
        pickBy(b, (value) => value !== undefined),
        comparisonFunc,
    );
};

// only works for arrays of integers and/or strings.
export function isEqualArrayContent (a, b) {
    if (!isArray(a) || !isArray(b)) return false;

    return isEmpty(xor(a, b));
}

export const isEqualExcludeUndefined = (a, b) => isEqualWith(a, b, comparisonFunc);
